$(".tabs-collection-slider").slick({
  dots: false,
  infinite: true,
  centerMode: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$("#mush_slide").slick({
  dots: false,
  infinite: true,
  centerMode: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

jQuery(document).ready(function ($) {
  // Initialize the Slick slider
  $("#mush_slider").slick({
    dots: true,
    infinite: true,
    centerMode: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

  // Play/pause video on click and pause others
  $(".mush_slide_video video").click(function () {
    // Pause all other videos
    $(".mush_slide_video video").each(function () {
      if (this !== event.target) {
        this.pause();
      }
    });

    // Play or pause the clicked video
    this.paused ? this.play() : this.pause();
  });
});

$(".custom_video_slider_col video").click(function () {
  this.paused ? this.play() : this.pause();
});

$("#logo_slider").owlCarousel({
  autoplay: true,
  slideTransition: "linear",
  autoplayTimeout: 3000,
  autoplaySpeed: 3000,
  dots: !1,
  nav: !0,
  center: !0,
  items: 3,
  margin: 60,
  loop: !0,
  responsive: {
    0: {
      margin: 0,
      items: 2,
      nav: !0,
    },
    600: {
      items: 3,
      nav: !0,
    },
    1e3: {
      items: 5,
      nav: !0,
    },
    1600: {
      items: 8,
      nav: !0,
    },
  },
});

// TWO COLUMNS SLIDER
$(document).ready(function () {
  var $slider = $("#two_col_slider");
  var $progressBar = $(".progress");
  var $progressBarLabel = $(".slider__label");

  $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var calc = (nextSlide / (slick.slideCount - 1)) * 100;

    $progressBar
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);

    $progressBarLabel.text(calc + "% completed");
  });

  $slider.slick({
    autoplay: true,
    infinite: true,
    centerMode: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  // Reapply background images after Slick is initialized and whenever it's updated
  $slider.on("setPosition", function () {
    $(".two_column_section_col").each(function () {
      var bgUrl = $(this).data("bg-url");
      $(this).css("background-image", "url(" + bgUrl + ")");
    });
  });

  // Initial reapply after Slick initialization
  setTimeout(function () {
    $(".two_column_section_col").each(function () {
      var bgUrl = $(this).data("bg-url");
      $(this).css("background-image", "url(" + bgUrl + ")");
    });
  }, 100); // Adjust the delay as needed
});

// TWO COLUMNS SLIDER END

$("#customer_reviews").slick({
  dots: false,
  infinite: true,
  centerMode: true,
  speed: 300,
  slidesToShow: 2,
  autoplay: true,
  autoplaySpeed: 6000,
  vertical: true,
  slidesToScroll: 1,
  verticalSwiping: true,
  arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

// MUSHROOM SLIDER
$(document).ready(function () {
  // Initialize Slick for images
  $("#mushpage_images").slick({
    dots: false,
    infinite: true,
    centerMode: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: "#mushpage_content",
  });

  // Initialize Slick for content
  $("#mushpage_content").slick({
    dots: false,
    infinite: true,
    centerMode: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: "#mushpage_images",
  });

  // Add 'active' class to the first title initially
  $(".mushroom_title_list p").first().addClass("active");

  $("#mushpage_images").on(
    "afterChange",
    function (event, slick, currentSlide) {
      // Remove 'active' class from all titles
      $(".mushroom_title_list p").removeClass("active");
      // Add 'active' class to the current title
      $(
        '.mushroom_title_list p[data-slide-index="' + currentSlide + '"]'
      ).addClass("active");
    }
  );

  // Make titles clickable
  $(".mushroom_title_list p").on("click", function () {
    // Get the slide index from the clicked title
    var slideIndex = $(this).attr("data-slide-index");
    // Remove 'active' class from all titles
    $(".mushroom_title_list p").removeClass("active");
    // Add 'active' class to the clicked title
    $(this).addClass("active");
    // Go to the corresponding slide in the Slick carousel
    $("#mushpage_images").slick("slickGoTo", slideIndex);
  });
});

// IMAGE LIST SLIDER
$("#custom__list_content").slick({
  dots: false,
  infinite: true,
  centerMode: true,
  speed: 300,
  slidesToShow: 3,
  vertical: true,
  slidesToScroll: 1,
  verticalSwiping: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
});

// CUSTOM VIDEO SLIDER
$("#video_slider").slick({
  dots: false,
  infinite: true,
  centerMode: true,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
});

function openTab(event, tabId) {
  var i, tabContents, tabButtons;

  // Remove customActive class from all tab contents
  tabContents = document.getElementsByClassName("customTabContent");
  for (i = 0; i < tabContents.length; i++) {
    tabContents[i].classList.remove("customActive"); // Remove customActive class from all tab contents
  }

  // Remove customActive class from all tab buttons
  tabButtons = document.getElementsByClassName("customTabLinks");
  for (i = 0; i < tabButtons.length; i++) {
    tabButtons[i].className = tabButtons[i].className.replace(
      " customActive",
      ""
    );
  }

  // Add customActive class to the button and the tab content
  document.getElementById(tabId).classList.add("customActive"); // Add customActive class to the current tab content
  event.currentTarget.className += " customActive";
}

function openCity(e, t) {
  var a, l, s;
  for (
    a = 0, l = document.getElementsByClassName("tabcontent");
    a < l.length;
    a++
  )
    l[a].style.display = "none";
  for (
    a = 0, s = document.getElementsByClassName("tablinks");
    a < s.length;
    a++
  )
    s[a].className = s[a].className.replace(" active", "");
  (document.getElementById(t).style.display = "block"),
    (e.currentTarget.className += " active");
}
$(".rev").click(function () {
  $("button").removeClass("op");
});

$(document).ready(function () {
  setTimeout(function () {
    $(
      ".shopify-block.shopify-app-block .bv_main_container .bv_stars_component_container svg path"
    ).removeAttr("style");
  }, 4000);
});
$(document).ready(function () {
  setTimeout(function () {
    var $span = $(".rc-radio:first-child .rc-radio__label");
    var textContent = $span.text();

    // Use a regular expression to find the price
    var price = textContent.match(/\$\d+\.\d{2}/)[0];

    // Remove the price from the original text content
    var newTextContent = textContent.replace(price, "").trim();

    // Set the modified text content back to the span
    $span.text(newTextContent);

    // Append the price in a new span element
    $span.append('<span class="extracted-price">' + price + "</span>");
  }, 4000);
});
$(".customproduct_tab button:first-child").addClass("customActive");
$(".customTabContent:first-child").addClass("customActive");
$(document).ready(function () {
  // Hide all collapse elements except the first one
  $(".new_collapse").not(":first").css("display", "none");

  // Show the first collapse element by default
  $(".new_collapse:first").css("display", "block");

  // Click event handler for faq_tab elements
  $(".faq_btn_title .faq_tab").click(function () {
    var tabId = $(this).attr("id"); // Get the ID of the clicked tab

    // Remove active class from all faq_tab elements
    $(".faq_btn_title .faq_tab").removeClass("active");

    // Add active class to the clicked faq_tab element
    $(this).addClass("active");

    // Hide all collapse elements except the one with corresponding ID
    $(".new_collapse")
      .not("#" + tabId)
      .css("display", "none");

    // Show the collapse element corresponding to the clicked tab
    $(".new_collapse#" + tabId).css("display", "block");
  });
});
$(".faq_btn_title:first-child .faq_tab").addClass("active");
$(document).ready(function () {
  $(".slick-slide:nth-child(4) .mush_slide_video video")
    .prop("autoplay", true)
    .prop("muted", true);
});

$(document).ready(function () {
  setTimeout(function () {
    var $span = $("quick-add-modal .rc-radio:first-child .rc-radio__label");
    var textContent = $span.text();

    // Use a regular expression to find the price
    var price = textContent.match(/\$\d+\.\d{2}/)[0];

    // Remove the price from the original text content
    var newTextContent = textContent.replace(price, "").trim();

    // Set the modified text content back to the span
    $span.text(newTextContent);

    // Append the price in a new span element
    $span.append('<span class="extracted-price">' + price + "</span>");
  }, 10000);
});
